import { render, staticRenderFns } from "./new_trusteeshio_msg.vue?vue&type=template&id=3703fd69&scoped=true&"
import script from "./new_trusteeshio_msg.vue?vue&type=script&lang=js&"
export * from "./new_trusteeshio_msg.vue?vue&type=script&lang=js&"
import style0 from "./new_trusteeshio_msg.vue?vue&type=style&index=0&id=3703fd69&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3703fd69",
  null
  
)

export default component.exports